import {
    CLEAR_REFERRAL_CODE,
    FETCH_REFERRAL_CODES, FETCH_REFERRAL_CODES_SUCCESS, FETCH_REFERRAL_CODES_FAILURE,
    SAVE_REFERRAL_CODE, SAVE_REFERRAL_CODE_SUCCESS, SAVE_REFERRAL_CODE_FAILURE,
    EMPTY_REFERRAL_CODES, SET_REFERRAL_CODE, SET_REFERRAL_CODES
} from './constants';

import { request, requestConfig } from 'utils/request';
import { PATHS } from 'utils/paths';

export const clearReferralCode = () => ({
    type: CLEAR_REFERRAL_CODE
});

export const emptyReferralCodes = () => ({
    type: EMPTY_REFERRAL_CODES
});

const fetchReferralCodes = (hideSpinner) => ({
    type: FETCH_REFERRAL_CODES,
    hideSpinner
});

const fetchReferralCodesSuccess = (data, meta) => ({
    type: FETCH_REFERRAL_CODES_SUCCESS,
    data,
    meta
});

const fetchReferralCodesFailure = (error) => ({
    type: FETCH_REFERRAL_CODES_FAILURE,
    error
});

const saveReferralCode = () => ({
    type: SAVE_REFERRAL_CODE
});

const saveReferralCodeSuccess = (data) => ({
    type: SAVE_REFERRAL_CODE_SUCCESS,
    data
});

const saveReferralCodeFailure = (error) => ({
    type: SAVE_REFERRAL_CODE_FAILURE,
    error
});

export const setReferralCode = (data) => ({
    type: SET_REFERRAL_CODE,
    data
});

export const setReferralCodes = (data) => ({
    type: SET_REFERRAL_CODES,
    data
});


/**
 *  ASYNC ACTIONS
 */
export const getReferralCodes = (isUpdate) => (dispatch, getStore) => {
    dispatch(fetchReferralCodes(isUpdate));

    let page = 0;

    if(isUpdate) {
        page = getStore().referralCodes.allMetadata.page + 1;
    }

    return request(PATHS.referralCodes.get(page), requestConfig('GET', null, getStore().auth.token))
        .then((response) => {
            let rows = response.data;
            if(isUpdate) {
                rows = getStore().referralCodes.all.concat(rows);
            }
            dispatch(fetchReferralCodesSuccess(rows, {page}));
            return response;
        })
        .catch((error) => {
            console.log('error saving referralCodes', error);
            error.friendlyMessage = 'There was an error saving these referralCodes. Please try again.';
            dispatch(fetchReferralCodesFailure(error));
            return error;
        });
};

export const putReferralCode = () => (dispatch, getStore) => {
    dispatch(saveReferralCode());

    let referralCode = getStore().referralCodes.referralCode;
    let method = 'PUT';
    let path = PATHS.referralCodes.save(referralCode.id);

    if(!referralCode.id) {
        method = 'POST';
        path = PATHS.referralCodes.create();
    }

    return request(path, requestConfig(method, referralCode, getStore().auth.token))
        .then((response) => {
            console.log(response);
            dispatch(saveReferralCodeSuccess(response.data));
            dispatch(getReferralCodes());
            return response;
        })
        .catch((error) => {
            console.log('error saving referralCode', error);
            error.friendlyMessage = 'There was an error saving this referralCode. Please try again.';
            dispatch(saveReferralCodeFailure(error));
            return error;
        });
};



// WEBPACK FOOTER //
// ./src/containers/ReferralCodesPage/store/actions.js